import { Route as ReactRoute, Router as ReactRouter, Switch } from 'react-router';
import Routes from './Routes';
import App from 'views/App';
import Communicate from 'views/App/Communicate';
import Help from 'views/App/Help';
import Home from 'views/App/Home';
import Organize from 'views/App/Organize';
import Share from 'views/App/Share';
import ErrorPage from 'pages/ErrorPage';
import Postcard from 'views/App/Communicate/Postcard';
import HelpDocuments from 'views/App/Help/HelpDocuments';
import Teamviewer from 'views/App/Help/Teamviewer';
import browserHistory from '../utils/history';
import TabletTutorials from 'views/App/Help/HelpDocuments/TabletTutorials';
import Admin from 'views/App/Admin';
import AcceptRelationship from 'views/AcceptRelationship';
import Profile from 'views/Profile';
import GettingStarted from 'views/App/Help/HelpDocuments/GettingStarted';
import FamilyPortalTutorials from 'views/App/Help/HelpDocuments/FamilyPortalTutorials';
import PartnerList from 'views/App/Help/PartnerList';
import PartnerPublications from 'views/App/Help/Partner/PartnerPublications';
import AdminMessages from 'views/App/Admin/AdminMessages';
import AdminWorkbook from 'views/App/Admin/AdminWorkbook';
import AdminOrganizer from 'views/App/Admin/AdminOrganizer';
import AdminBookmarks from 'views/App/Admin/AdminBookmarks';
import AdminApplications from 'views/App/Admin/AdminApplications';
import AdminContacts from 'views/App/Admin/AdminContacts';
import AdminMessageViewer from 'views/App/Admin/AdminMessages/AdminMessageViewer';
import AdminSettingsUserInformationsPage from '@/components/ui/pages/admin/settings/AdminSettingsUserInformationsPage';
import AdminSettingsAccountInformationsPage from '@/components/ui/pages/admin/settings/AdminSettingsAccountInformationsPage';
import AdminSettingsCommunicatePage from '@/components/ui/pages/admin/settings/AdminSettingsCommunicatePage';
import ProtectedRoute from './ProtectedRoute';
import VideoCallPage from 'views/App/Communicate/Video/VideoCallPage';
import VideoCallsHome from 'views/App/Communicate/Video/VideoCallsHome';
import VideoCallPageWithContext from 'views/App/Communicate/Video/VideoCallPageWithContext';
import VideoCallExpired from 'views/App/Communicate/Video/VideoCallExpired';
import AdminSettingsSoundPage from '@/components/ui/pages/admin/settings/AdminSettingsSoundPage';
import AdminSettingsDisplayPage from '@/components/ui/pages/admin/settings/AdminSettingsDisplayPage';

/* The more precise URL first */
const Router = (): JSX.Element => (
  <ReactRouter history={browserHistory}>
    <Switch>
      <ReactRoute path={Routes.ERROR}>
        <ErrorPage />
      </ReactRoute>

      <ReactRoute path={Routes.VIDEO_CALL_PAGE}>
        <VideoCallPage />
      </ReactRoute>

      <ReactRoute path={Routes.VIDEO_CALL_PAGE_EXPIRED}>
        <VideoCallExpired />
      </ReactRoute>

      <ReactRoute path={Routes.POSTCARD}>
        <ProtectedRoute>
          <App>
            <Postcard />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.VIDEO_CALL_PAGE_WITH_CHANNEL}>
        <ProtectedRoute>
          <App>
            <VideoCallPageWithContext />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.VIDEO_CALL_LIST}>
        <ProtectedRoute>
          <App>
          <VideoCallsHome />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.COMMUNICATE}>
        <ProtectedRoute>
          <App>
            <Communicate />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.SHARE}>
        <ProtectedRoute>
          <App>
            <Share />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ORGANIZE}>
        <ProtectedRoute>
          <App>
            <Organize />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.TABLET_TUTORIALS}>
        <ProtectedRoute>
          <App>
            <TabletTutorials />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.GETTING_STARTED}>
        <ProtectedRoute>
          <App>
            <GettingStarted />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.FAMILY_PORTAL_TUTORIALS}>
        <ProtectedRoute>
          <App>
            <FamilyPortalTutorials />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.HELP_DOCUMENTS}>
        <ProtectedRoute>
          <App>
            <HelpDocuments />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.TEAMVIEWER}>
        <ProtectedRoute>
          <App>
            <Teamviewer />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.PARTNER_LIST}>
        <ProtectedRoute>
          <App>
            <PartnerList />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.PARTNER_CONTENTS}>
        <ProtectedRoute>
          <App>
            <PartnerPublications />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.HELP}>
        <ProtectedRoute>
          <App>
            <Help />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_MESSAGE_VIEWER}>
        <ProtectedRoute>
          <App>
            <AdminMessageViewer />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_MESSAGES}>
        <ProtectedRoute>
          <App>
            <AdminMessages />
          </App>
        </ProtectedRoute>
        
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_WORKBOOK}>
        <ProtectedRoute>
          <App>
            <AdminWorkbook />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_ORGANIZER}>
        <ProtectedRoute>
          <App>
            <AdminOrganizer />
          </App>
        </ProtectedRoute>
        
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_BOOKMARKS}>
        <ProtectedRoute>
          <App>
            <AdminBookmarks />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_APPLICATIONS}>
        <ProtectedRoute>
          <App>
            <AdminApplications />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_SETTINGS_GENERAL_USER_INFOS}>
      <ProtectedRoute>
          <App>
              <AdminSettingsUserInformationsPage />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_SETTINGS_APPLICATION_COMMUNICATE}>
        <ProtectedRoute>
          <App>
            <AdminSettingsCommunicatePage />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      
      <ReactRoute path={Routes.ADMIN_SETTINGS_TABLET_SOUND}>
        <ProtectedRoute>
          <App>
            <AdminSettingsSoundPage />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_SETTINGS_TABLET_DISPLAY}>
        <ProtectedRoute>
          <App>
            <AdminSettingsDisplayPage />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN_CONTACTS}>
        <ProtectedRoute>
          <App>
            <AdminContacts />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ADMIN}>
        <ProtectedRoute>
          <App>
            <Admin />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.ACCEPT_RELATIONSHIP}>
        <ProtectedRoute>
          <AcceptRelationship />
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.PROFILE}>
        <ProtectedRoute>
          <App>
            <Profile />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path={Routes.HOME}>
        <ProtectedRoute>
          <App>
            <Home />
          </App>
        </ProtectedRoute>
      </ReactRoute>

      <ReactRoute path="/">
        <ProtectedRoute>
          <App />
        </ProtectedRoute>
      </ReactRoute>
    </Switch>
  </ReactRouter>
);

export default Router;
